import { useMemo } from 'react';
import * as Routes from './constants';
import useCasinoRoutes from './use-casino-routes';

const useRouteMap = () => {
	const casinoRoutes = useCasinoRoutes();

	const routes = useMemo(
		() => ({
			casino: casinoRoutes.ROUTE_CASINO_EXPLORE,
			livecasino: casinoRoutes.ROUTE_LIVE_CASINO_EXPLORE,
			explore: casinoRoutes.ROUTE_CASINO_EXPLORE,
			livebetting: Routes.ROUTE_LIVEBETTING,
			sportsbook: Routes.ROUTE_SPORTSBOOK
		}),
		[casinoRoutes.ROUTE_CASINO_EXPLORE, casinoRoutes.ROUTE_LIVE_CASINO_EXPLORE]
	);

	return routes;
};

export default useRouteMap;
